var map = {
	"./vg-00001.jpg": 9963,
	"./vg-00002.jpg": 4774,
	"./vg-00003.jpg": 33,
	"./vg-00004.jpg": 8288,
	"./vg-00005.jpg": 9402,
	"./vg-00006.jpg": 6910,
	"./vg-00007.jpg": 5404,
	"./vg-00008.jpg": 584,
	"./vg-00009.jpg": 6795,
	"./vg-00010.jpg": 3543,
	"./vg-00011.jpg": 1926,
	"./vg-00012.jpg": 1316,
	"./vg-00013.jpg": 5754,
	"./vg-00014.jpg": 1925,
	"./vg-00015.jpg": 6272,
	"./vg-00016.jpg": 2392,
	"./vg-00017.jpg": 7376,
	"./vg-00018.jpg": 7715,
	"./vg-00019.jpg": 2324,
	"./vg-00020.jpg": 796,
	"./vg-00021.jpg": 7326,
	"./vg-00022.jpg": 2422,
	"./vg-00023.jpg": 7824,
	"./vg-00024.jpg": 676,
	"./vg-00025.jpg": 5004,
	"./vg-00026.jpg": 9433,
	"./vg-00027.jpg": 8345,
	"./vg-00028.jpg": 1985,
	"./vg-00029.jpg": 9798,
	"./vg-00030.jpg": 5470,
	"./vg-00031.jpg": 8260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1550;